// import { Link } from "react-router-dom";
// import {
//   Tags,
//   FolderTree,
//   Search,
//   ShoppingCart,
//   Globe,
//   CheckCircle,
//   Layers,
//   Workflow,
//   ArrowRight,
// } from "lucide-react";

// const CategorizingTagging = () => {
//   const services = [
//     {
//       icon: Tags,
//       title: "Content Tagging",
//       description:
//         "Accurate keyword and attribute tagging to improve discoverability.",
//     },
//     {
//       icon: FolderTree,
//       title: "Metadata Structuring",
//       description:
//         "Consistent metadata schemas for scalable content organization.",
//     },
//     {
//       icon: Search,
//       title: "Taxonomy Design",
//       description:
//         "Custom hierarchical taxonomies aligned with business objectives.",
//     },
//     {
//       icon: ShoppingCart,
//       title: "Dataset Organization",
//       description: "Logical classification enabling fast retrieval and reuse.",
//     },
//   ];

//   const benefits = [
//     "Improved enterprise search accuracy",
//     "Consistent metadata across platforms",
//     "Enhanced personalization & recommendations",
//     "Reduced manual classification effort",
//     "Faster content discovery",
//     "Scalable information architecture",
//   ];

//   const useCases = [
//     {
//       title: "E-Commerce",
//       desc: "Product categorization, attributes & faceted navigation.",
//     },
//     {
//       title: "Media Libraries",
//       desc: "Image, video & audio tagging for faster retrieval.",
//     },
//     {
//       title: "Enterprise Knowledge",
//       desc: "Document classification & internal search optimization.",
//     },
//     {
//       title: "Digital Asset Management",
//       desc: "Structured DAM labeling and lifecycle management.",
//     },
//   ];

//   const industries = [
//     "Retail & E-Commerce",
//     "Media & Entertainment",
//     "Healthcare",
//     "Education",
//     "Corporate Enterprises",
//     "Digital Asset Platforms",
//   ];

//   const process = [
//     {
//       title: "Content Analysis",
//       desc: "Understand data types, usage patterns & business goals.",
//     },
//     {
//       title: "Taxonomy Definition",
//       desc: "Design scalable classification and metadata standards.",
//     },
//     {
//       title: "Tagging Execution",
//       desc: "Apply consistent tags using expert review processes.",
//     },
//     {
//       title: "Quality Validation",
//       desc: "Multi-level checks to ensure accuracy and consistency.",
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-white font-inter">
//       {/* HERO */}
//       <section className="relative h-[500px] overflow-hidden bg-slate-900">
//         {/* Background Image */}
//         <div
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage:
//               "url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&q=80')",
//           }}
//         />

//         {/* Dark overlay */}
//         <div className="absolute inset-0 bg-black/75" />

//         <div className="relative max-w-7xl mx-auto px-6 h-full flex items-center">
//           <div className="text-white max-w-3xl">
//             <h1 className="text-4xl sm:text-5xl font-light mb-4 tracking-tight">
//               Categorization & Tagging Services
//             </h1>

//             <p className="text-lg text-slate-300 max-w-2xl mb-6 font-light">
//               Transform unstructured content into structured, searchable, and
//               intelligent information systems.
//             </p>

//             <Link
//               to="/contact"
//               className="inline-flex items-center gap-2 bg-white text-slate-900 px-7 py-3 rounded-md font-medium hover:bg-slate-100 transition-colors"
//             >
//               Get Started
//               <ArrowRight className="w-4 h-4" />
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* SERVICES */}
//       <section className="py-24 px-6">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Our Core Services
//           </h2>

//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {services.map((s) => (
//               <div
//                 key={s.title}
//                 className="p-8 bg-slate-900 text-white hover:bg-slate-800 transition"
//               >
//                 <s.icon className="w-8 h-8 mb-4" />
//                 <h3 className="text-xl font-medium mb-2">{s.title}</h3>
//                 <p className="text-slate-300 text-sm font-light">
//                   {s.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* WHY IT MATTERS */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-6xl mx-auto text-center">
//           <h2 className="text-4xl font-light mb-6">
//             Why Categorization Matters
//           </h2>
//           <p className="text-lg text-slate-600 max-w-3xl mx-auto mb-16 font-light">
//             Effective categorization unlocks content value by improving search,
//             automation, analytics, and user experience.
//           </p>

//           <div className="grid md:grid-cols-3 gap-6">
//             {benefits.map((b, i) => (
//               <div key={i} className="p-6 bg-white border border-slate-200">
//                 <CheckCircle className="w-6 h-6 mb-3 text-slate-700" />
//                 <p className="font-light text-slate-800">{b}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* USE CASES */}
//       <section className="py-24 px-6">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Common Use Cases
//           </h2>

//           <div className="grid md:grid-cols-2 gap-6">
//             {useCases.map((u) => (
//               <div
//                 key={u.title}
//                 className="p-8 bg-slate-50 border border-slate-200"
//               >
//                 <Layers className="w-6 h-6 text-slate-700 mb-4" />
//                 <h3 className="text-xl font-medium mb-2">{u.title}</h3>
//                 <p className="text-slate-600 font-light">{u.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* INDUSTRIES */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Industries We Support
//           </h2>

//           <div className="grid md:grid-cols-3 gap-6">
//             {industries.map((ind) => (
//               <div
//                 key={ind}
//                 className="p-8 bg-white border border-slate-200 text-center"
//               >
//                 <Globe className="w-6 h-6 mx-auto mb-3 text-slate-700" />
//                 <p className="font-light">{ind}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* PROCESS */}
//       <section className="py-24 px-6 bg-slate-900 text-white">
//         <div className="max-w-6xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Our Workflow
//           </h2>

//           <div className="space-y-6">
//             {process.map((p, i) => (
//               <div
//                 key={p.title}
//                 className="flex gap-6 p-8 bg-slate-800 border border-slate-700"
//               >
//                 <div className="w-12 h-12 bg-white text-slate-900 flex items-center justify-center">
//                   {i + 1}
//                 </div>
//                 <div>
//                   <h3 className="text-xl font-medium mb-1">{p.title}</h3>
//                   <p className="text-slate-300 font-light">{p.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="py-24 bg-white border-t border-slate-200">
//         <div className="max-w-4xl mx-auto text-center px-6">
//           <h2 className="text-3xl sm:text-4xl font-light mb-8">
//             Ready to Organize Your Data?
//           </h2>
//           <p className="text-slate-600 font-light mb-8">
//             Build scalable, searchable, and intelligent content systems with
//             expert categorization services.
//           </p>
//           <Link
//             to="/contact"
//             className="inline-flex items-center gap-2 bg-slate-900 text-white px-8 py-3 font-medium"
//           >
//             Start Categorizing <ArrowRight className="w-4 h-4" />
//           </Link>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default CategorizingTagging;

import { Link } from "react-router-dom";
import {
  Tags,
  FolderTree,
  Search,
  ShoppingCart,
  Globe2,
  CheckCircle2,
  Layers,
  ArrowRight,
  Database,
  ShieldCheck,
  Zap,
  Music,
  Stethoscope,
  GraduationCap,
  Clapperboard,
  Building2,
} from "lucide-react";
import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

const CategorizingTagging = () => {
  const services = [
    {
      icon: Tags,
      title: "Content Taxonomy",
      description:
        "Engineering precise keyword and attribute hierarchies to drive intelligent discoverability.",
    },
    {
      icon: FolderTree,
      title: "Metadata Orchestration",
      description:
        "Architecting consistent metadata schemas for scalable, multi-platform content ecosystems.",
    },
    {
      icon: Search,
      title: "Semantic Labeling",
      description:
        "Custom classification models aligned with complex enterprise business objectives.",
    },
    {
      icon: Database,
      title: "Dataset Structuring",
      description:
        "Logical data organization enabling high-velocity retrieval and cross-functional reuse.",
    },
  ];

  const industries = [
    {
      icon: ShoppingCart,
      name: "Retail & E-Commerce",
      desc: "Product categorization and faceted navigation logic.",
    },
    {
      icon: Clapperboard,
      name: "Media & Entertainment",
      desc: "Large-scale image, video, and audio asset tagging.",
    },
    {
      icon: Stethoscope,
      name: "Healthcare",
      desc: "Medical record classification and diagnostic metadata.",
    },
    {
      icon: GraduationCap,
      name: "Education",
      desc: "Structured learning paths and digital library organization.",
    },
    {
      icon: Building2,
      name: "Corporate Enterprises",
      desc: "Internal knowledge base and document classification.",
    },
    {
      icon: Globe2,
      name: "Digital Asset Platforms",
      desc: "Scalable DAM labeling and lifecycle management.",
    },
  ];

  return (
    <main className="min-h-screen bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Information Architecture
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">Data Tagging</span> &
              Logic.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              Transforming fragmented, unstructured content into high-fidelity,
              searchable assets through expert classification and semantic
              labeling.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg"
            >
              Consult an Expert <ArrowRight size={16} className="ml-1" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* ================= CORE SERVICES ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Service Catalog
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Structured Data Solutions
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((s, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-100 bg-white hover:border-indigo-100 hover:shadow-xl transition-all"
              >
                <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-6 shadow-sm">
                  <s.icon size={24} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {s.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {s.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= INDUSTRIES WE SUPPORT (NEW CONTENT) ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Domain Expertise
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Industries We Support
            </h2>
            <p className="text-slate-500 text-sm mt-2 font-light">
              Precision tagging workflows tailored to specific industry
              verticals.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {industries.map((ind, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                transition={{ delay: idx * 0.1 }}
                className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm hover:border-indigo-500/30 transition-all flex items-start gap-5"
              >
                <div className="w-10 h-10 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0">
                  <ind.icon size={20} />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900 text-sm mb-1">
                    {ind.name}
                  </h4>
                  <p className="text-xs text-slate-500 leading-relaxed font-light">
                    {ind.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= STRATEGIC VALUE (DARK ACCENT) ================= */}
      <section className="py-24 bg-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-12 gap-8 items-stretch">
            <motion.div
              {...fadeUp}
              className="lg:col-span-12 bg-[#0f172a] p-10 md:p-16 rounded-[2.5rem] text-white relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/10 blur-[100px] rounded-full" />
              <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
                <div>
                  <ShieldCheck className="text-indigo-400 mb-6" size={40} />
                  <h3 className="text-3xl font-bold mb-4 tracking-tight">
                    Why Categorization Matters
                  </h3>
                  <p className="text-slate-400 text-lg font-light leading-relaxed mb-8">
                    Effective metadata isn't just about storage—it's about
                    search precision, automation potential, and user experience.
                    Our workflows ensure a <strong>99.9% accuracy index</strong>{" "}
                    across all taxonomies.
                  </p>
                  <div className="flex flex-wrap gap-3">
                    {[
                      "Enterprise Search",
                      "AI Training",
                      "Auto-Personalization",
                      "SOC2 Compliant",
                    ].map((tag) => (
                      <div
                        key={tag}
                        className="px-4 py-2 bg-white/5 border border-white/10 rounded-full text-[10px] font-bold uppercase tracking-widest text-indigo-400"
                      >
                        {tag}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="grid sm:grid-cols-2 gap-4">
                  {[
                    "Search Accuracy",
                    "Consistent Schema",
                    "Recommendation Ready",
                    "Scalable IA",
                  ].map((item) => (
                    <div
                      key={item}
                      className="flex items-center gap-3 bg-white/5 p-4 rounded-xl border border-white/10 backdrop-blur-sm"
                    >
                      <CheckCircle2
                        size={18}
                        className="text-indigo-400 shrink-0"
                      />
                      <span className="text-sm font-medium text-slate-200">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden border-t border-white/5 text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 tracking-tight">
            Structure Your Digital Ecosystem.
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Build a scalable foundation for your information systems. Let's
            discuss your technical roadmap and classification requirements
            today.
          </p>
          <div className="flex justify-center gap-4">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-10 py-3.5 rounded-xl font-bold text-sm hover:bg-indigo-50 transition-all shadow-xl shadow-black/20"
            >
              Initiate Technical Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CategorizingTagging;